// Copyright (c) 2016 Deere & Company

import Dealer from './dealer';
import KeyValuePair from './key-value-pair';
import t from 'tcomb';

const OpenPipPrograms = t.struct({
    comments: t.maybe(t.String),
    completedPins: t.maybe(t.Number),
    completionPercent: t.maybe(t.Number),
    daysRemaining: t.maybe(t.Number),
    description: t.maybe(t.String),
    expireDate: t.maybe(t.Number),
    gracePeriodPins: t.maybe(t.Number),
    internalRecall: t.maybe(t.String),
    leadAccount: t.maybe(Dealer),
    metric: t.maybe(KeyValuePair),
    participant: t.maybe(KeyValuePair),
    pipNumber: t.maybe(t.String),
    pipStatus: t.maybe(KeyValuePair),
    pipType: t.maybe(KeyValuePair),
    responsibleAccount: t.maybe(Dealer),
    startDate: t.maybe(t.Number),
    statusReason: t.maybe(t.String),
    terminationDate: t.maybe(t.Number),
    totalPins: t.maybe(t.Number)
}, {
    name: 'OpenPipPrograms',
    strict: true
});

export const getDefaultState = () => new OpenPipPrograms({
});

export default OpenPipPrograms;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/open-pip-programs.js